import { useEffect, useState } from "react";

const DOTS = [6.22263, 28.2868, 51.1296];
const CYCLE_MS = 380;

/**
 * Animated NutriCoach smile loader ("Glyph" in the building Figma frame): three
 * dots pulse left-to-right above a smile arc that fades from the dark background
 * into cream. Used as an indeterminate loading indicator.
 */
export const OnboardingSmileLoader = ({ className }: { className?: string }) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setActive((prev) => (prev + 1) % DOTS.length), CYCLE_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <svg
      className={className}
      width="55.2778"
      height="40.4447"
      viewBox="0 0 55.2778 40.4447"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M26.9631 40.4447C42.0002 40.4447 51.1608 30.2471 54.9633 24.889C45.1114 33.7039 38.8533 36.7096 28.0002 37.8521C18.1482 38.8891 4.14817 31.6298 0 25.9261C2.07409 29.5557 10.338 40.4447 26.9631 40.4447Z"
        fill="url(#onboarding-smile-gradient)"
      />
      {DOTS.map((cx, i) => (
        <circle
          key={cx}
          cx={cx}
          cy={4.14817}
          r={4.14817}
          fill="#FBF6F0"
          className="transition-opacity duration-300"
          style={{ opacity: active === i ? 1 : 0.3 }}
        />
      ))}
      <defs>
        <linearGradient
          id="onboarding-smile-gradient"
          x1="0"
          y1="25.9261"
          x2="48.741"
          y2="34.7409"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#140D31" />
          <stop offset="1" stopColor="#FBF6F0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
